"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarcodeIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class BarcodeIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                React.createElement("g", { id: "icon/24/barcode/barcode-light", fill: fill },
                    React.createElement("g", { transform: "translate(3.000000, 7.000000)" },
                        React.createElement("rect", { x: "0", y: "0", width: "1", height: "10" }),
                        React.createElement("rect", { x: "2", y: "0", width: "2", height: "10" }),
                        React.createElement("rect", { x: "5", y: "0", width: "1", height: "10" }),
                        React.createElement("rect", { x: "8", y: "0", width: "3", height: "10" }),
                        React.createElement("rect", { x: "12", y: "0", width: "1", height: "10" }),
                        React.createElement("rect", { x: "14", y: "0", width: "2", height: "10" }),
                        React.createElement("rect", { x: "17", y: "0", width: "1", height: "10" }))))));
    }
}
exports.BarcodeIcon = BarcodeIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/barcode.tsx
// module id = 2127
// module chunks = 0 1 2